import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const loandepotLogoLarge = svgToTinyDataUri(
  `<svg width="180" height="48" viewBox="0 0 180 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <text x="15" y="36" font-family="Arial, sans-serif" font-size="28" font-weight="bold" fill="url(#gradient)">loanDepot</text>
  <defs>
    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:#7c3aed;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#a855f7;stop-opacity:1" />
    </linearGradient>
  </defs>
</svg>`
);
